var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        ref: "productList",
        staticClass: "product-list row grid",
        class: { "home-cat-list__more--load": !_vm.mounted },
      },
      _vm._l(_vm.visibleItems, function (item) {
        return _c(
          "div",
          { staticClass: "col-6 col-md-4 col-lg-3" },
          [
            _c("category-item", {
              key: item.id,
              attrs: { "item-data": item.data },
            }),
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    !_vm.lastPage && !_vm.is404
      ? _c("div", { staticClass: "d-flex justify-content-center" }, [
          _c(
            "button",
            {
              staticClass: "home-highlight-items__btn",
              attrs: { disabled: _vm.loading },
              on: {
                click: function ($event) {
                  return _vm.updateVisibleItems(true)
                },
              },
            },
            [
              _vm.loading
                ? [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate(
                            "HoferAntikschmuck::Template.loadMoreLoading"
                          )
                        ) +
                        "\n                "
                    ),
                  ]
                : [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$translate(
                            "HoferAntikschmuck::Template.loadMoreItems"
                          )
                        ) +
                        "\n\n\t\t\t\t\t"
                    ),
                    _c("svg", { attrs: { stroke: "currentColor" } }, [
                      _c("use", { attrs: { "xlink:href": "#chevron-down" } }),
                    ]),
                  ],
            ],
            2
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }